"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCallbackQuery = exports.useMutation = exports.useQuery = exports.useClient = exports.createClient = exports.Client = void 0;
const useCallbackOrQueryMutation_1 = require("./useCallbackOrQueryMutation");
var fetching_1 = require("./fetching");
Object.defineProperty(exports, "Client", { enumerable: true, get: function () { return fetching_1.Client; } });
Object.defineProperty(exports, "createClient", { enumerable: true, get: function () { return fetching_1.createClient; } });
var useClient_1 = require("./useClient");
Object.defineProperty(exports, "useClient", { enumerable: true, get: function () { return useClient_1.useClient; } });
var useQuery_1 = require("./useQuery");
Object.defineProperty(exports, "useQuery", { enumerable: true, get: function () { return useQuery_1.useQuery; } });
function useMutation(mutation, ...args) {
    return (0, useCallbackOrQueryMutation_1.useCallbackQueryOrMutation)('mutation', mutation, ...args);
}
exports.useMutation = useMutation;
function useCallbackQuery(query, ...args) {
    return (0, useCallbackOrQueryMutation_1.useCallbackQueryOrMutation)('query', query, ...args);
}
exports.useCallbackQuery = useCallbackQuery;
